import React, { FC } from "react";
import { get } from "lodash";
import { getLocalstorageToken } from "src/context/AuthHelper";
import {
  NACHWEIS_POSITION_STATUS,
  PLATZHALTER_TEXT,
} from "src/lib/constants/constant";
import { TreeNodeType } from "src/lib/types/types";
import ApplicationHeading from "src/pages/private/online-antrag/application-heading/ApplicationHeading";
import SachausgabenLoeweInputMA from "./SachausgabenLoeweInputMA";
import SachausgabenUebersichtLoeweMA from "./SachausgabenUebersichtLoeweMA";
import { getLoeweMittelabrufOrganizations } from "./LoeweMittelabrufOrganizations";

const SachausgabenLoeweMA: FC = () => (
  <ApplicationHeading title="Sachausgaben" description={PLATZHALTER_TEXT} />
);

export const getSachausgabenLoeweMAChildren = (
  application: any,
): TreeNodeType[] => {
  const applicantOrganizationId = get(getLocalstorageToken(), "organisationId");

  return getLoeweMittelabrufOrganizations(
    application,
    applicantOrganizationId,
  ).map((organization) => ({
    label: organization.label,
    content: (
      <>
        <SachausgabenLoeweInputMA
          nachweisPositionStatus={
            NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben
          }
          organizationId={organization.id}
          kostentraeger={organization.kostentraeger}
        />
        <SachausgabenLoeweInputMA
          nachweisPositionStatus={NACHWEIS_POSITION_STATUS.geplant}
          organizationId={organization.id}
          kostentraeger={organization.kostentraeger}
        />
      </>
    ),
    showError: false,
  }));
};

export const SachausgabenUebersichtParentLoeweMA: FC = () => (
  <ApplicationHeading title="Sachausgaben Übersicht" />
);

export const getSachausgabenUebersichtLoeweMAChildren = (
  application: any,
): TreeNodeType[] => {
  const applicantOrganizationId = get(getLocalstorageToken(), "organisationId");

  return getLoeweMittelabrufOrganizations(
    application,
    applicantOrganizationId,
  ).map((organization) => ({
    label: organization.label,
    content: (
          <SachausgabenUebersichtLoeweMA
        organizationId={organization.id}
        kostentraeger={organization.kostentraeger}
        hideHeading
      />
    ),
    showError: false,
  }));
};

export default SachausgabenLoeweMA;
